"use client";

import { createContext, useContext } from "react";

export const StatusPageLayoutContext = createContext(false);

export const useStatusPageLayout = () => useContext(StatusPageLayoutContext);
